import constants from './constants';

const initialState = {
    url: '',
    eventName:''
};

export default (state = initialState, action) => {
  switch (action.type) {
      case constants.REDIRECT_TO:
          return { ...state, url: action.data.url, eventName: action.data.eventName }
    default:
      return state;
  }
}